// extracted by mini-css-extract-plugin
module.exports = {"root":"Expandable_root__V0ZCO","--active":"Expandable_--active__IYm0_","inner":"Expandable_inner__baRGx"};